export const MAX_BLOCK_HEIGHT_DIFFERENCE = 50;
